// extracted by mini-css-extract-plugin
module.exports = {"root":"Countries_root__37OxD","fullSize":"Countries_fullSize__26PKo","message":"Countries_message__3PsJY"};